import React, { useEffect } from 'react';

import IDepartamento from '../interfaces/IDepartament';

interface UserDepartamentProps {
  userDepartament: IDepartamento[];
  alignContent?: string;
}

const UserDepartament: React.FC<UserDepartamentProps> = ({
  userDepartament,
  alignContent = 'justify-content-start',
}) => {
  return (
    <div className={`d-flex flex-wrap ms-2 `}>
      {userDepartament?.map((departament: IDepartamento) => (
        <div
          key={departament.seqDepartamento}
          className="rounded-pill me-2 mt-2"
          style={{
            backgroundColor:
              departament.cor === null ? '#616161' : departament.cor,
          }}
        >
          <span className="ms-2 me-2" style={{ color: '#fff' }}>
            {departament.nome}
          </span>
        </div>
      ))}
    </div>
  );
};

UserDepartament.defaultProps = {
  alignContent: 'justify-content-center',
};

export default UserDepartament;
